module.exports = __webpack_public_path__ + "img/home_icon_renwuzhongxin.0a4cd43a.svg";